/* eslint-disable react/prop-types */
import React from 'react';
import FormConfigs from 'components/Molecules/Forms/WithFieldConfigs/container/index';
import { generateFieldPosition, generateFields } from '../../../helper';
import Derived from '../../../Fields/Derived';
import { Middlewares } from '../../../middlewares/index';
import { Switch } from '../../../Fields/switch';
import Checkbox from '../../../Fields/Checkbox';
import classes from './Section.module.scss';
import { FIELD_POSITIONS } from './constants';

export const Section = (props) => {
  const { field, value } = props;
  const { config, raw } = field;
  const { configs: sectionFieldConfigs } = config || {};
  const generatedSectionFields = generateFields([...raw.fields], sectionFieldConfigs);

  return (
    <div className={classes.section}>
      <FormConfigs
        className={classes.form}
        disabled
        layout="vertical"
        initialValues={{ ...value, enabled: raw.enabled }}
        FIELD_PROVIDER={{
          SWITCH: Switch,
          DERIVED: Derived,
          CHECKBOX: Checkbox,
        }}
        fields={generateFieldPosition(
          [
            {
              type: 'SWITCH',
              name: 'enabled',
              switchProps: {
                label: raw.label,
              },
            },
            ...generatedSectionFields,
          ],
          FIELD_POSITIONS
        )}
        middlewares={[...Middlewares]}
        renderMiddlewares={[
          (sectionField, meta) => {
            const { FIELD_PROVIDER } = meta;
            const Element = FIELD_PROVIDER[sectionField.type];
            if (!Element) return null;
            return <Element {...sectionField} {...meta} />;
          },
        ]}
      />
    </div>
  );
};
